import { cn } from '@/shared/utils/cn'

interface LogoProps {
  collapsed?: boolean
  className?: string
}

export function Logo({ collapsed, className }: LogoProps) {
  if (collapsed) {
    return (
      <img
        src="/assets/images/qsc-logo.svg"
        alt="BizBee QSC"
        className={cn(
          'size-9 rounded-lg object-contain',
          className,
        )}
      />
    )
  }

  return (
    <img
      src="/assets/images/qsc-login-logo.svg"
      alt="BizBee QSC"
      className={cn('h-9 w-[140px] shrink-0 object-contain', className)}
    />
  )
}
